<template>
  <div>
    <sticky-breadcrumb>
      <v-layout row wrap>
        <v-flex sm6 xs12 py-0>
          <h2>Product View</h2>
          <p v-if="getCurrentProduct.brand">Brand: {{getCurrentProduct.brand}}</p>
          <p v-if="getCurrentProduct.name">Name: {{getCurrentProduct.name}}</p>
          <p v-if="getCurrentProduct.sku && getCurrentProduct.sku.length > 0">
            SKU:
            <span v-for="(item, index) in getCurrentProduct.sku" :key="index">
              {{item}}
            </span>
          </p>
        </v-flex>
        <v-flex sm6 xs12 py-0>

          <div class="dropdown-filter-primary-group">
            <v-hover
              v-slot="{ hover }"
              open-delay="200"
              v-if="!!getCurrentProduct.id"
            >
              <v-btn class="mb-1" icon @click="open_report_dialog" >
                <v-icon v-if="!report.done" :color="(hover) ? 'red' : undefined" >report</v-icon>
                <v-icon v-else color="success">check_circle</v-icon>
              </v-btn>
            </v-hover>
            <div class="dropdown-filter-primary lg ml-2">
              <v-autocomplete
                v-model="filter.product.object"
                :items="getProducts"
                :loading="filter.product.isLoading"
                :search-input.sync="filter.product.search"
                :ripple="false"
                return-object
                background-color="rgba(48, 127, 255, 0.1)"
                clearable
                noFilter
                hide-details
                prepend-inner-icon="search"
                append-icon=""
                item-text="product_name"
                item-value="id"
                label="Search product or sku ..."
                solo
                flat
                @change="report.done = false"
              >
                <template v-slot:item="{ item }">
                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.product_name"></v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
              <div class="search-count" v-if="getProducts && getProducts.length > 0">
                {{getProducts.length}}
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </sticky-breadcrumb>
    <v-container fluid grid-list-xl pa-0>
      <v-layout row wrap>
        <template v-if="getCurrentProduct.id || getCurrentSku.sku">
          <v-flex lg6 md6 sm6 xs12>
            <app-card>
              <price-tracking
                :filters="priceTracking"
                :chart="getPriceTracking"
                :currentProduct="getCurrentProduct"
                :currentSku="getCurrentSku" />
            </app-card>
          </v-flex>
          <v-flex lg6 md6 sm6 xs12>
            <app-card>
              <availability-tracking
                :filters="availabilityTracking"
                :chart="getAvailabilityTracking"
                :currentProduct="getCurrentProduct"
                :currentSku="getCurrentSku" />
            </app-card>
          </v-flex>

          <!--Data Table-->
          <v-flex xs12>
            <app-card>
              <div class="app-card-header primary-actions">
                <div class="heading-block">
                  <h4 class="heading">Sellers</h4>
                </div>
                <div class="actions-block">
                  <div class="d-flex align-center">
                    <p class="mr-3">Data Status</p>
                    <i-checkbox
                      v-model="sellersTable.statuses.showExcellent"
                      label="Excellent"
                      tooltipLabel
                      color="success"
                    />
                    <i-checkbox
                      v-model="sellersTable.statuses.showVeryGood"
                      label="Very Good"
                      tooltipLabel
                      color="success-min"
                    />
                    <i-checkbox
                      v-model="sellersTable.statuses.showGood"
                      label="Good"
                      tooltipLabel
                      color="warning"
                    />
                    <i-checkbox
                      v-model="sellersTable.statuses.showPoor"
                      label="Poor"
                      tooltipLabel
                      color="danger"
                    />
                  </div>
                  <div class="dropdown-filter">
                    <i-text-field
                      solo
                      type="text"
                      width="180px"
                      placeholder="Search ..."
                      tooltipLabel
                      v-model="sellersTable.search"
                    />
                  </div>
                </div>
              </div>
              <div class="card-body pa-0">
                <v-data-table
                  :headers="sellersTable.headers"
                  :items="getSellersTable.items"
                  :search="sellersTable.search"
                  :loading="getSellersTable.loading"
                  :pagination.sync="sellersTable.pagination"
                  :rows-per-page-items="sellersTable.pagination.rowsPerPageItems"
                  class="i-table"
                >
                  <template v-slot:items="props">
                    <template v-if="(props.item.price_status === 0 && sellersTable.statuses.showExcellent) || (props.item.price_status === 1 && sellersTable.statuses.showVeryGood) || (props.item.price_status === 2 && sellersTable.statuses.showGood) || (props.item.price_status === 3 && sellersTable.statuses.showPoor)">
                      <tr class="status-row" :class="{'row-emphasised' : props.item.my_seller === '1', 'excellent-row' : props.item.price_status === 0, 'very-good-row' : props.item.price_status === 1, 'good-row' : props.item.price_status === 2, 'poor-row' : props.item.price_status === 3}" :data-id="props.item.track_id">
                        <td class="text-xs-left">{{ props.item.seller_name }}</td>
                        <td class="text-xs-left">{{ props.item.price }}</td>
                        <td class="text-xs-left">{{ props.item.availability === 0 ? '' : props.item.availability }}</td>
                        <td class="text-xs-left">{{ props.item.shipping }}</td>
                        <td class="text-xs-left">{{ props.item.color_variation }}</td>
                        <td class="text-xs-left">{{ props.item.min_price }}</td>
                        <td class="text-xs-left">{{ props.item.sku }}</td>
                        <td class="text-xs-left">{{ props.item.last_price_alt }}</td>
                        <!--<td class="text-xs-left break-all td-sm"><a :href="props.item.url" target="blank">{{ props.item.url.length > 35 ? props.item.url.substring(0, 35) + '...' : props.item.url }}</a></td>-->
                        <td class="text-xs-left break-all"><a :href="props.item.url" target="_blank"><v-icon color="primary">link</v-icon></a></td>
                      </tr>
                    </template>
                  </template>
                </v-data-table>
              </div>
            </app-card>
          </v-flex>

          <!--Old Table-->
          <v-flex xs12>
            <app-card :fill-height="false" v-if="getOldTable.items.length > 0">
              <div class="card-body pa-0">
                <v-data-table
                  :items="getOldTable.items"
                  :loading="getOldTable.loading"
                  :pagination.sync="oldTable.pagination"
                  :rows-per-page-items="oldTable.pagination.rowsPerPageItems"
                  hide-headers
                  class="i-table"
                >
                  <template v-slot:items="props">
                    <tr class="status-row old-row" :class="{'row-emphasised' : props.item.my_seller === '1'}" :data-id="props.item.track_id">
                      <td class="text-xs-left">{{ props.item.seller_name }}</td>
                      <td class="text-xs-left">{{ props.item.price }}</td>
                      <td class="text-xs-left">{{ props.item.availability === 0 ? '' : props.item.availability }}</td>
                      <td class="text-xs-left">{{ props.item.shipping }}</td>
                      <td class="text-xs-left">{{ props.item.price_with_shipping }}</td>
                      <td class="text-xs-left">{{ props.item.min_price }}</td>
                      <td class="text-xs-left">{{ props.item.max_price }}</td>
                      <td class="text-xs-left">{{ props.item.last_price_alt }}</td>
                      <td class="text-xs-left break-all"><a :href="props.item.url" target="_blank">{{ props.item.url.length > 35 ? props.item.url.substring(0, 35) + '...' : props.item.url }}</a></td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </app-card>
          </v-flex>
        </template>
        <i-no-results v-else heading="Oops!" title="No matching Search Results" sub-title="Try to search for something with search filed above"></i-no-results>
      </v-layout>
    </v-container>
    <v-dialog
      v-model="report_dialog" max-width="700"
      scrollable
      @click:outside="report_dialog = false"
    >
      <v-card>
        <v-card-title class="title justify-center">Report a problem for {{ getCurrentProduct.product_name }}</v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-autocomplete
              label="Issue"
              v-model="report.issue"
              :items="issues"
              multiple
              attach
              overflow:initial
              clearable
              @change="report.competitors = []"
            ></v-autocomplete>
            <v-autocomplete
              label="Competitors"
              v-model="report.competitors"
              :items="(!report.issue.includes('Missing Url')) ? getReportSellers : competitors"
              item-text="name"
              item-value="id"
              multiple
              attach
              overflow:initial
              clearable
              return-object
              :disabled="!report.issue.length"
            ></v-autocomplete>
            <v-textarea
              v-model="report.comments"
              label="Comments"
              placeholder="Tell us more about it..."
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="flex-row justify-space-around">
          <v-btn
            outline
            color="primary"
            @click="submit_report"
            :disabled="!report.issue.length || !report.competitors.length || (report.issue.includes('Other') && !report.comments.length)"
          >done</v-btn>
          <v-btn outline color="primary" @click="report_dialog = false">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import priceTracking from '../components/productView/priceTracking'
import availabilityTracking from '../components/productView/availabilityTracking'
import { AppUrl } from '@/assets/js/variables'
import axios from 'axios'

export default {
  name: 'ProductView',
  components: {
    priceTracking,
    availabilityTracking
  },
  data: () => ({
    filter: {
      product: {
        object: null,
        isLoading: false,
        items: [],
        model: null,
        search: null
      },
      sku: {
        object: null,
        isLoading: false,
        items: [],
        model: null,
        search: null
      },
      brand: {
        model: ''
      }
    },
    priceTracking: {
      loading: false,
      search: '',
      seller: {
        isLoading: false,
        items: [],
        model: [],
        search: null
      },
      date: {
        model: 1,
        modelText: 'Last 24 Hours',
        items: [{key: '1', value: 'Last 24 Hours'}, {key: '2', value: 'Last Week'}, {key: '3', value: 'Last Month'}, {key: '4', value: 'Last 3 Months'}, {key: '5', value: 'Last 6 Months'}]
      }
    },
    availabilityTracking: {
      loading: false,
      search: '',
      seller: {
        isLoading: false,
        items: [],
        model: 0,
        search: null
      },
      date: {
        model: 1,
        modelText: 'Last 24 Hours',
        items: [{key: '1', value: 'Last 24 Hours'}, {key: '2', value: 'Last Week'}, {key: '3', value: 'Last Month'}, {key: '4', value: 'Last 3 Months'}, {key: '5', value: 'Last 6 Months'}]
      }
    },
    sellersTable: {
      headers: [
        {text: 'Seller Name', value: 'seller_name'},
        {text: 'Selling price', value: 'selling_price'},
        {text: 'Availability', value: 'availability'},
        {text: 'Shipping', value: 'shipping'},
        {text: 'Color', value: 'color'},
        {text: 'Minimum Price 30 days', value: 'minimum_price_30_days'},
        {text: 'Sku', value: 'sku'},
        {text: 'Last Price alteration', value: 'last_price_alteration'},
        {text: 'URL', value: 'url'}
      ],
      pagination: {
        sortBy: 'selling_price',
        rowsPerPageItems: [10, 25, 50, 100],
        rowsPerPage: 50
      },
      statuses: {
        showExcellent: true,
        showVeryGood: true,
        showGood: true,
        showPoor: false
      }
    },
    oldTable: {
      pagination: {
        rowsPerPageItems: [10, 25, 50, 100],
        rowsPerPage: 50
      }
    },
    report_dialog: false,
    report: {
      issue: [],
      competitors: [],
      comments: '',
      done: false
    },
    issues: [
      'Wrong Match',
      'Wrong Price',
      'Wrong Availability',
      'Wrong Shipping',
      'Missing Url',
      'Other'
    ],
    competitors: []
  }),
  computed: {
    getProducts () {
      return this.$store.state.productViewModule.products
    },
    getSkus () {
      return this.$store.state.productViewModule.skus
    },
    getCurrentProduct () {
      return this.$store.state.productViewModule.currentProduct
    },
    getCurrentSku () {
      return this.$store.state.productViewModule.currentSku
    },
    getPriceTracking () {
      return this.$store.state.productViewModule.priceTracking
    },
    getAvailabilityTracking () {
      return this.$store.state.productViewModule.availabilityTracking
    },
    getSellersTable () {
      return this.$store.state.productViewModule.sellersTable
    },
    getOldTable () {
      return this.$store.state.productViewModule.oldTable
    },
    clientName () {
      return this.$store.state.auth.accountParams.client_name
    },
    getReportSellers () {
      return this.$store.state.productViewModule.reportSellers
    },
    report_sku () {
      return this.$store.state.productViewModule.reportSKU
    }
  },
  methods: {
    dispatchSellersTable () {
      this.$store.dispatch('productViewModule/getSellerTable', {
        productId: this.getCurrentProduct.id,
        moduleId: 3
      })
    },
    open_report_dialog () {
      this.getCompetitors()
      Object.assign(this.report, {
        issue: [],
        competitors: [],
        comments: '',
        done: false
      })
      this.report_dialog = true
    },
    async submit_report () {
      const extras = {
        product: this.getCurrentProduct,
        client_name: this.clientName,
        product_sku: this.report_sku
      }
      const report = Object.assign({}, extras, this.report)
      const payload = {
        task: 'send_product_report',
        payload: report
      }
      try {
        const { data } = await axios.post(AppUrl, payload)
        if (data) this.report.done = true
        console.log('respond', data)
      } catch ({ name, message }) {
        console.log(name)
        console.log('message', message)
      } finally {
        this.report_dialog = false
      }
    },
    async getCompetitors () {
      if (this.competitors.length) return
      const payload = {
        task: 'getCompetitorsOfClient',
        payload: {
          client_name: this.clientName,
          product: this.getCurrentProduct
        }
      }
      try {
        const { data } = await axios.post(AppUrl, payload)
        this.competitors = data.payload.competitors.map(c => ({
          id: c.seller_id,
          name: c.seller_name
        }))
        console.log('respond', data)
      } catch ({ name, message }) {
        console.log('name', name)
        console.log('message', message)
      }
    }
  },
  watch: {
    // Product Search
    'filter.product.search': function (val) {
      if (val === '' || val === null || val === undefined) {
        if (this.filter.product.object) {
          this.filter.product.object.id = 0
        } else {
          this.filter.product.object = {}
          this.filter.product.object.id = 0
        }
        return
      }
      // Don't send request on selection
      if (this.getProducts.length > 0) {
        let BreakException = {}
        try {
          this.getProducts.forEach(el => {
            if (val === el.product_name) {
              throw BreakException
            }
          })
        } catch (e) {
          if (e !== BreakException) throw e
          return
        }
      }
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.filter.product.isLoading = true
        this.$store.dispatch('productViewModule/getProduct', {
          productName: val,
          sku: this.filter.product.model,
          pageId: 'product'
        }).then(() => {
          this.filter.product.isLoading = false
        })
      }, 300)
    },
    'filter.product.object': function (val) {
      if (val === '' || val === null || val === undefined) {
        if (this.filter.product.object) {
          this.filter.product.object.id = 0
        } else {
          this.filter.product.object = {}
          this.filter.product.object.id = 0
        }
        return
      }
      setTimeout(() => {
        // this.filter.sku.search = ''
        this.$store.commit('productViewModule/SET_resetCurrentSku')
        this.$store.commit('productViewModule/SET_currentProduct', {
          object: this.filter.product.object
        })
        this.$store.dispatch('productViewModule/getPriceTracking', {
          productId: this.getCurrentProduct.id,
          sku: this.getCurrentSku.sku ? this.getCurrentSku.sku : '',
          sellerId: 0,
          altDate: this.priceTracking.date.model,
          moduleId: 1,
          chartRef: this.$refs.priceTrackingChart
        })
        this.$store.dispatch('productViewModule/getAvailabilityTracking', {
          productId: this.getCurrentProduct.id,
          sku: this.getCurrentSku.sku ? this.getCurrentSku.sku : '',
          sellerId: 0,
          altDate: this.availabilityTracking.date.model,
          moduleId: 2,
          chartRef: this.$refs.availabilityTrackingChart
        })
        this.dispatchSellersTable()
      }, 0)
    },
    // SKU
    'filter.sku.search': function (val) {
      if (val === '' || val === null || val === undefined) {
        if (this.filter.sku.object) {
          this.filter.sku.object.id = 0
        } else {
          this.filter.sku.object = {}
          this.filter.sku.object.id = 0
        }
        return
      }
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.filter.sku.isLoading = true
        this.$store.dispatch('productViewModule/getSku', {
          sku: val,
          pageId: 'product'
        }).then(() => {
          this.filter.sku.isLoading = false
        })
      }, 300)
    },
    'filter.sku.object': function (val) {
      if (val === '' || val === null || val === undefined) {
        this.filter.sku.object.model = 0
        return
      }
      setTimeout(() => {
        this.$store.commit('productViewModule/SET_resetCurrentProduct')
        this.$store.commit('productViewModule/SET_currentSku', {
          object: this.filter.sku.object
        })
        this.$store.dispatch('productViewModule/getPriceTracking', {
          productId: this.getCurrentProduct.id ? this.getCurrentProduct.id : 0,
          sku: this.getCurrentSku.sku,
          sellerId: 0,
          altDate: this.priceTracking.date.model,
          moduleId: 1,
          chartRef: this.$refs.priceTrackingChart
        })
        this.$store.dispatch('productViewModule/getAvailabilityTracking', {
          productId: this.getCurrentProduct.id ? this.getCurrentProduct.id : 0,
          sku: this.getCurrentSku.sku,
          sellerId: 0,
          altDate: this.availabilityTracking.date.model,
          moduleId: 2,
          chartRef: this.$refs.availabilityTrackingChart
        })
        this.dispatchSellersTable()
      }, 0)
    }
  }
}
</script>

<style scoped>
.select-report {
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/views/ProductView.vue